import LocalizedStrings from 'react-localization';

import pocen from '../assets/svg/desktop/Racializedpeople_en.svg';
import pocfr from '../assets/svg/desktop/Racializedpeople_fr.svg';
import indigenousen from '../assets/svg/desktop/IndigenousPeoples_en.svg';
import indigenousfr from '../assets/svg/desktop/IndigenousPeoples_fr.svg';
import pwden from '../assets/svg/desktop/PersonswithDisabilities_en.svg';
import pwdfr from '../assets/svg/desktop/PersonswithDisabilities_fr.svg';
import womenen from '../assets/svg/desktop/Women_en.svg';
import womenfr from '../assets/svg/desktop/Women_fr.svg';
import LGBTQen from '../assets/svg/desktop/LGBTQ2_en.svg';
import LGBTQfr from '../assets/svg/desktop/LGBTQ2_fr.svg';


import Mpocen from '../assets/svg/mobile/Racializedpeople_en.svg';
import Mpocfr from '../assets/svg/mobile/Racializedpeople_fr.svg';
import Mindigenousen from '../assets/svg/mobile/IndigenousPeoples_en.svg';
import Mindigenousfr from '../assets/svg/mobile/IndigenousPeoples_fr.svg';
import Mpwden from '../assets/svg/mobile/PersonswithDisabilities_en.svg';
import Mpwdfr from '../assets/svg/mobile/PersonswithDisabilities_fr.svg';
import Mwomenen from '../assets/svg/mobile/Women_en.svg';
import Mwomenfr from '../assets/svg/mobile/Women_fr.svg';
import MLGBTQen from '../assets/svg/mobile/LGBTQ2_en.svg';
import MLGBTQfr from '../assets/svg/mobile/LGBTQ2_fr.svg';



let strings = new LocalizedStrings({

    en: {
        title: "A changing workforce",
        content: "Our audiences are evolving, and so are we. We are committed to creating and maintaining a workforce that reflects Canada.",
        industry: "Labour force availability",
        cbc: "Representation at CBC/Radio-Canada",
        POC: {
            gifM: Mpocen,
            gif: pocen,
            title: "Racialized people"
        },
        indigneousPeoples: {
            gifM: Mindigenousen,
            gif: indigenousen,
            title: "Indigenous Peoples"
        },
        PWD: {
            gifM: Mpwden,
            gif: pwden,
            title: "Persons with disabilities"
        },
        women: {
            gifM: Mwomenen,
            gif: womenen,
            title: "Women"
        },
        LGBTQ: {
            gifM: MLGBTQen,
            gif: LGBTQen,
            title: "**LGBTQ2+"
        },

        footnote: "*Includes all employees in roles of 13+ weeks. Employees on leave are excluded. Labour force availability is based on the 2016 Statistics Canada census (for Indigenous peoples, racialized people and women) and 2017 Canadian Survey on Disability (for persons with disabilities)",
        footnote2: "**LGBTQ2+: Lesbian, gay, bisexual, transgender, queer, two-spirit and other gender and sexual diversity. The Canadian Labour Force availability for this group is not available from Statistics Canada and is therefore not reported."
    },
    fr: {
        title: "Un effectif en évolution",
        content: "Nos auditoires évoluent, et nous aussi. Nous sommes résolus à constituer et à maintenir un effectif qui reflète le Canada.",
        industry: "Disponibilité dans l’industrie",
        cbc: "Représentation à CBC/Radio-Canada",
        POC: {
            gifM: Mpocfr,
            gif: pocfr,
            title: "Personnes racisées"
        },
        indigneousPeoples: {
            gifM: Mindigenousfr,
            gif: indigenousfr,
            title: "Autochtones"
        },
        PWD: {
            gifM: Mpwdfr,
            gif: pwdfr,
            title: "Personnes en situation d'handicap"
        },
        women: {
            gifM: Mwomenfr,
            gif: womenfr,
            title: "Femmes"
        },
        LGBTQ: {
            gifM: MLGBTQfr,
            gif: LGBTQfr,
            title: "**Membres des communautés LGBTQ2+"
        },
        footnote: "*Comprend tous les employés dans des postes de 13 semaines et plus. Les employés en congé sont exclus. La disponibilité dans l’industrie est basée sur le recensement de 2016 (pour les Autochtones, les personnes racisées et les femmes) et l’Enquête canadienne sur l’incapacité de 2017 (pour les personnes en situation de handicap) de Statistique Canada",
        footnote2: "**LGBTQ2+ : Lesbiennes, gais, bisexuels, transgenres, queers, bispirituels et autres diversité sexuelle et des genres. La disponibilité de la main-d'œuvre canadienne pour ce groupe n'est pas disponible auprès de Statistique Canada et n'est donc pas rapportée.",

    }
});

export default strings;